const responseMessage = {
  ERROR: {
    
  },
  SUCCESS: {
    
  },
};

  /**
 * METHOD: displayErrorMessage(param)
 * RETURN ERROR MESSAGES USING ERRORCODE
 */
export function displayErrorMessage(errorArray) {
  const newErrorArray = [];
  for (const key of errorArray) { // eslint-disable-line
    newErrorArray.push(responseMessage.ERROR[key]);
  }
  return newErrorArray;
}

export function displaySuccessMessage(successArrayKey) {
  const newSuccesArray = responseMessage.SUCCESS[successArrayKey];
  return newSuccesArray;
}

export default responseMessage;